const oauth = {
    oauth: {
        register: "SIGN UP",
        login: "LOG IN"
    }
};

export default oauth;
